export default "__VITE_ASSET__BKzb63$V__"